export default {
  title: 'Tworzenie paczki wniosków',
  properties: {
    nodeId: { type: 'number' },
    schoolName: { title: 'Wybierz szkołę', type: 'string', computed: true }
  }
};
